/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

export const BaseProductListingFragment = gql`
  fragment BaseProductListingFragment on ProductListing {
    __typename
    sys {
      id
    }
    assemblyManual {
      url
      title
      description
      contentType
    }
    filterTagAttributeIds
    jumpLink
    jumpLinkMarginTop
    productCard {
      url
      title
      description
      contentType
    }
    title
  }
`;
